import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';
import { useEffect, useState } from 'react';
import { KitCard } from '@/components/catalog/ProductCard';
import { CategoryNav } from '@/components/home/CategoryNav';
import { HeroBannerSlider } from '@/components/home/HeroBannerSlider';
import { CategoryProductCarousels } from '@/components/home/CategoryProductCarousels';
import { InfoStrip } from '@/components/home/InfoStrip';
import { compraConfianzaItems } from '@/data/homeContent';
import { SectionHeader } from '@/components/ui';
import { api } from '@/lib/api';
import { MOCK_KITS } from '@/data/mockCatalog';
import type { Kit } from '@/types';

export function HomePage() {
  const [kits, setKits] = useState<Kit[]>([]);

  useEffect(() => {
    api
      .kits()
      .then((kitsRes) => {
        if (kitsRes?.length) {
          setKits(kitsRes.slice(0, 2));
        } else {
          setKits(MOCK_KITS.slice(0, 2));
        }
      })
      .catch(() => setKits(MOCK_KITS.slice(0, 2)));
  }, []);

  return (
    <>
      <HeroBannerSlider />
      <CategoryNav />

      <InfoStrip />

      <CategoryProductCarousels />

      <section className="border-t border-surface-200 bg-surface-100 py-12">
        <div className="container-app">
          <SectionHeader
            eyebrow="Sistemas completos"
            title="Kits para tu instalación"
            subtitle="Cámaras, grabador, sensores o panel: piezas ya elegidas. Revisa la lista y compra con un solo precio."
            action={{ label: 'Ver todos los kits', to: '/kits' }}
          />
          <div className="mt-6 grid gap-6 md:grid-cols-2">
            {kits.map((k) => (
              <KitCard key={k.id_kit} kit={k} />
            ))}
          </div>
          <div className="mt-6 lg:hidden">
            <Link to="/kits" className="btn-secondary">
              <Package className="h-4 w-4" />
              Todos los kits
            </Link>
          </div>
        </div>
      </section>

      <section className="page-section-alt">
        <div className="container-app max-w-3xl">
          <SectionHeader
            title="Compra con confianza"
            subtitle="Lo que debes saber antes de pagar"
          />
          <dl className="mt-6 divide-y divide-surface-200 border border-surface-200 bg-white">
            {compraConfianzaItems.map(({ title, desc }) => (
              <div key={title} className="grid gap-1 px-4 py-4 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:px-5">
                <dt className="text-sm font-semibold text-surface-900">{title}</dt>
                <dd className="text-sm leading-relaxed text-surface-600">{desc}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>
    </>
  );
}
